import Components from "slotworks/components/components";
import Result from "slotworks/model/gameplay/records/results/result";
import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";
import Point from "slotworks/utils/geom/point";

export function getWinningSymbols(results: Result[]) {
    let winningPositions: Point[] = [];

    for (const win of results) {
        if (win instanceof SymbolWinResult) {
            winningPositions = winningPositions.concat(win.positions);
        }
    }

    const winningSymbols = [];

    for (const position of winningPositions) {
        const symbol = Components.matrix.getSymbol(position.x, position.y);
        winningSymbols.push(symbol);
    }

    return winningSymbols;
}
